import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import UploadBannerImage from "./UploadBannerImage";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Close } from "@mui/icons-material";
import { styles } from "../../styles/styles";
import {
  createActivityBanner,
  createActivityBannerImage,
  createHomeBanner,
  createHomeBannerImage,
} from "../../redux/banners/actions/actions";

const MySwal = withReactContent(Swal);

const AddHomeBanner = ({ open, onClose, handleRefresh, activity }) => {
  const theme = useTheme();
  const [isRoute, setIsRoute] = useState(false);

  const validationSchema = Yup.object().shape({
    // Define validation rules for your form fields
  });

  const [imageUpload, setImageUpload] = useState("");
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const routes = [
    { id: 1, value: "Sponsor", name: "Sponsor" },
    { id: 1, value: "Commerce", name: "Comercio" },
    { id: 1, value: "Exchange", name: "Canjes" },
  ];
  const handleClose = () => {
    setImageUpload("");
    setImage("");

    onClose();
  };

  const formik = useFormik({
    initialValues: {
      link: "",
      isRoute: false,
      isLarge: false,
      imgURL: "",
      isWebView: false,
      route: "",
      screen: "",
      sponsorId: "",
      orderNumber: 0,
      isWebOnly: false,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      if (values.isRoute) {
        values.isWebView = false;
      } else {
        values.isWebView = true;
      }
      if (values.route === "Sponsor") {
        values.screen = "SponsorScreen";
      } else {
        values.screen = "";
        values.sponsorId = "";
      }
      const newData = {
        link: values.link,
        isRoute: values.isRoute,
        isLarge: values.isLarge,
        isWebView: values.isWebView,
        route: values.route,
        screen: values.screen,
        sponsorId: values.sponsorId,
        imgURL: values.imgURL,
        orderNumber: values.orderNumber,
        isWebOnly: values.isWebOnly,
      };

      const confirmResult = await MySwal.fire({
        title: "Confirmar adición",
        text: "¿Estás seguro de que deseas agregar este banner?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, agregar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      });

      if (confirmResult.isConfirmed) {
        setLoading(true);
        const loadingSwal = MySwal.fire({
          title: "Guardando...",
          html: '<div class="swal2-spinner"></div>',
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            MySwal.showLoading();
          },
        });
        try {
          if (activity) {
            const id = await createActivityBanner(newData);
            await createActivityBannerImage(imageUpload, id);
          } else {
            const id = await createHomeBanner(newData);
            await createHomeBannerImage(imageUpload, id);
          }

          setTimeout(() => {
            setLoading(false);
            resetForm();
            handleRefresh();
            onClose();
          }, 2000);

          loadingSwal.close();
          MySwal.fire("Guardado!", "", "success");
        } catch (error) {
          MySwal.fire("Error", "Hubo un error al agregar el banner", "error");
        }

        onClose();
        setTimeout(() => {
          setLoading(false);
          setImageUpload("");

          handleRefresh();
          onClose();
          loadingSwal.close();
        }, 1000);
      }
    },
  });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          width: "100%",
          backgroundImage: "none",
          overflowX: "hidden",
        },
      }}
    >
      <DialogTitle>
        {activity ? "Agregar Banner de Actividad" : "Agregar Banner de Home"}
        <Box sx={styles.closeButton} onClick={onClose}>
          <Close />
        </Box>
      </DialogTitle>
      <DialogContent>
        <form>
          <Box mt={2}>
            <Typography>General</Typography>
          </Box>
          <Grid container>
            <Grid item md={12}>
              <TextField
                margin="dense"
                variant="standard"
                fullWidth
                id="link"
                name="link"
                label="Enlace"
                value={formik.values.link}
                onChange={formik.handleChange}
                error={formik.touched.link && Boolean(formik.errors.link)}
                helperText={formik.touched.link && formik.errors.link}
              />
            </Grid>
          </Grid>
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid item md={5}>
              <FormControl sx={{ my: 2, width: "100%" }}>
                <InputLabel>Tamaño</InputLabel>
                <Select
                  native
                  value={formik.values.isLarge}
                  onChange={formik.handleChange}
                  name="isLarge"
                >
                  <option value={true}>Grande</option>
                  <option value={false}>Normal</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={5}>
              <TextField
                variant="standard"
                fullWidth
                type="number"
                id="item"
                name="orderNumber"
                label="Numero Orden"
                value={formik.values.orderNumber}
                onChange={formik.handleChange}
                error={
                  formik.touched.orderNumber &&
                  Boolean(formik.errors.orderNumber)
                }
                helperText={
                  formik.touched.orderNumber && formik.errors.orderNumber
                }
              />
            </Grid>
          </Grid>
          <FormControl
            component="fieldset"
            sx={{
              marginLeft: "0px !important",
              flexDirection: "row",
              marginBottom: "15px",
            }}
          >
            <FormControlLabel
              sx={{ marginLeft: "0px !important", flexDirection: "row" }}
              value="isWebOnly"
              label="isWebOnly"
              labelPlacement="start"
              control={
                <Checkbox
                  name="isWebOnly"
                  checked={formik.values.isWebOnly}
                  onChange={formik.handleChange}
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              }
            />
          </FormControl>
          <Box mt={2}>
            <Typography>App</Typography>
          </Box>
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid item md={5}>
              <FormControl sx={{ my: 2, width: "100%" }}>
                <InputLabel>Contiene ruta</InputLabel>
                <Select
                  native
                  value={formik.values.isRoute}
                  onChange={formik.handleChange}
                  name="isRoute"
                >
                  <option value={true}>Si</option>
                  <option value={false}>No</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={5}>
              {formik.values.isRoute && (
                <FormControl sx={{ my: 2, width: "100%" }}>
                  <InputLabel>Ruta app</InputLabel>
                  <Select
                    native
                    value={formik.values.route}
                    onChange={formik.handleChange}
                    name="route"
                  >
                    {routes.map((option) => (
                      <option value={option.value} key={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            mb={4}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid item md={12}>
              {formik.values.route === "Sponsor" && formik.values.isRoute && (
                <TextField
                  margin="dense"
                  variant="standard"
                  fullWidth
                  id="sponsorId"
                  name="sponsorId"
                  label="Id Sponsor"
                  value={formik.values.sponsorId}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.sponsorId && Boolean(formik.errors.sponsorId)
                  }
                  helperText={
                    formik.touched.sponsorId && formik.errors.sponsorId
                  }
                />
              )}
            </Grid>
          </Grid>

          <UploadBannerImage
            title={"Banner"}
            loadUrl={setFileUrl}
            imageUpload={imageUpload}
            setImageUpload={setImageUpload}
            setImage={setImage}
            image={image}
          />

          <DialogActions>
            <Button variant="contained" color="error" onClick={handleClose}>
              Cancelar
            </Button>
            <Button
              onClick={formik.handleSubmit}
              variant="contained"
              disabled={loading}
            >
              {loading ? "Guardando..." : "Agregar"}
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddHomeBanner;
